import _ from 'lodash';
import { IViz } from '../../interfaces';
import { Viz as VizUtil } from '../../VizUtil';
import { IAttribute } from '../../../datasets/interfaces';
import { TimePeriods } from '../../filter/relative-date-condition';
import {
  ISlicerOption,
  TimestampSlicerTypes,
  SelectStatus,
} from '../interfaces';

export const validateSlicers = (
  viz: IViz,
  slicers: IAttribute[] = [],
  slicerSelections: any[] = [],
): boolean => {
  const allFields = VizUtil.getAllAvailableFields(viz);
  const slicerNames = _.map(slicers, 'name');

  const hasIncludedField = fieldName => {
    return _.includes(_.map(allFields, 'name'), fieldName);
  };

  const areValidSlicerNames = _.every(slicerNames, hasIncludedField);

  const slicerSelectionFieldNames: string[] = _.uniq(
    _.map(slicerSelections, 'name'),
  );

  const areValidSlicerSelections = _.every(
    slicerSelectionFieldNames,
    (_fieldName: string) => {
      return (
        _.includes(slicerNames, _fieldName) && hasIncludedField(_fieldName)
      );
    },
  );

  return areValidSlicerNames && areValidSlicerSelections;
};

export const defaultTimestampSlicerOptions: ISlicerOption[] = [
  {
    option: JSON.stringify({
      type: TimestampSlicerTypes.CURRENT_AND_PREV,
      operands: ['7', TimePeriods.DAYS.key, 'false'],
    }),
    isSelected: true,
  },
];

export const joinBreadcrumbs = (
  name: string,
  breadcrumbs: string[] = [],
): string => [name].concat(breadcrumbs).join(' > ');

export const isStatusValid = (selectedStatus: string): boolean => {
  const validStatuses = [
    SelectStatus.SOME,
    SelectStatus.ALL,
    SelectStatus.SOME_SELECTED,
  ];
  return _.includes(validStatuses, selectedStatus);
};

export const isIndeterminateStatus = (selectedStatus: string): boolean =>
  selectedStatus === SelectStatus.SOME;
